import { AppBar, Button, IconButton, makeStyles, Toolbar, Typography } from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useDispatch } from "react-redux";
import { logout } from "../../store/admin";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({

  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

}));

const Header = ({handleDrawerToggle}:any) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const LogOut = () => {
    dispatch(logout());
    //condition checking to change state from true to false and vice versa
  };

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap style={{flexGrow: 1}}>
            Bangladesh Doctors Foundation
        </Typography>
        <Button color="inherit" onClick={LogOut}><ExitToAppIcon />&nbsp; Logout</Button>
      </Toolbar>
    </AppBar>
  );
};

export {Header};